"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductInfoLabel = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductInfoLabel = () => {
  const {
    labels,
    code
  } = (0, _contexts.useSearchPreviewProduct)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    ppa,
    deal
  } = labels ?? {};
  const shouldDisplayPpaLabel = (0, _react.useMemo)(() => (0, _presentationComponents.isPpaLabel)(ppa?.labelKey) && !!ppa.title, [ppa]);
  const shouldDisplayDealLabel = (0, _react.useMemo)(() => !shouldDisplayPpaLabel && _constants.allowedDealLabels.includes(deal?.labelKey ?? '') && !!deal?.title, [deal, shouldDisplayPpaLabel]);
  if (!shouldDisplayPpaLabel && !shouldDisplayDealLabel) {
    return null;
  }
  if (shouldDisplayPpaLabel) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LabelContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
        "data-testid": getTestId(`${_constants.PRODUCT_INFO_LABEL}-${code}`),
        label: ppa?.title,
        variant: "tag",
        color: "default"
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LabelContainer, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
      "data-testid": getTestId(`${_constants.PRODUCT_INFO_LABEL}-${code}`),
      label: deal?.title,
      variant: "filled",
      color: "default",
      size: "small"
    })
  });
};
exports.ProductInfoLabel = ProductInfoLabel;
//# sourceMappingURL=ProductInfoLabel.js.map